<section class="card">
  <h2>Planes</h2>
  <div class="flex items-center justify-between">
    <!-- <h5 class="m-0">Buscar Comercios</h5> -->
    <p-iconfield>
      <p-inputicon class="pi pi-search" />
      <input pInputText type="text" [(ngModel)]="searchTerm" placeholder="Busqueda Rápida" />
    </p-iconfield>
    <p-button label="Nuevo" icon="pi pi-plus" severity="success" [outlined]="true" (click)="goToAddSubscription()" iconPos="right" />
  </div>
  <div class="flex flex-wrap justify-around items-center">
    <div class="flex flex-col rounded-lg shadow-sm max-w-96 p-8 my-6 border border-slate-300" *ngFor="let subscription of filteredShopSubscriptions" [ngClass]="getBackgroundClass(subscription.shopSubscriptionId)">
      <div class="pb-8 m-0 mb-8 text-center text-slate-100 border-b border-slate-300 ">
        <p class="text-2xl font-semibold text-slate-100">
          {{ subscription.shopSubscriptionName }}
        </p>
        <!-- <h1 class="flex justify-center gap-1 mt-4 font-bold text-white text-6xl">
          <span class="text-3xl">$</span>29
          <span class="self-end text-3xl">/mo</span>
        </h1> -->
        <span>Tiendas Asociadas: {{ subscription.shopsActive || 0 }}</span>
      </div>
      <div class="p-0">
        <ul class="flex flex-col gap-2">
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              Hasta {{ subscription.shopMaxUsers }} usuarios
            </p>
          </li>
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              Hasta {{ subscription.shopMaxProducts }} productos
            </p>
          </li>
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              {{ getProductTypesAllowed(subscription.shopProductTypesAllow) }}
            </p>
          </li>
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" *ngIf="subscription.shopPosAccess == 1" style="color: white"></i>
              <i class="pi pi-times" *ngIf="subscription.shopPosAccess == 0" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              {{ subscription.shopPosAccess == 1? "POS" : "POS" }}
            </p>
          </li>
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" *ngIf="subscription.shopAnaliticsAccess == 1" style="color: white"></i>
              <i class="pi pi-times" *ngIf="subscription.shopAnaliticsAccess == 0" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              {{ subscription.shopAnaliticsAccess == 1? "Analitics" : "Analitics" }}
            </p>
          </li>
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" *ngIf="subscription.shopAnaliticsAccess == 1" style="color: white"></i>
              <i class="pi pi-times" *ngIf="subscription.shopAnaliticsAccess == 0" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              {{ subscription.shopInfobipIntegrationAllow == 1? "Chat App" : "Chat App" }}
            </p>
          </li>
          <li class="flex items-center gap-4">
            <span class="p-1 border rounded-full border-slate-500 bg-slate-700 flex items-center">
              <i class="pi pi-check" *ngIf="subscription.shopValidateClientAccess == 1" style="color: white"></i>
              <i class="pi pi-times" *ngIf="subscription.shopValidateClientAccess == 0" style="color: white"></i>
            </span>
            <p class="text-slate-100">
              {{ subscription.shopValidateClientAccess == 1? "Validación de Clientes" : "Validación de Clientes" }}
            </p>
          </li>
        </ul>
      </div>
      <div class="p-0 mt-12">
        <p-button label="Editar" class="w-full" styleClass="w-full" icon="pi pi-pen-to-square" severity="contrast" (click)="viewDetails(subscription.shopSubscriptionId)" iconPos="right" />
        <!-- <p-button label="Editar" class="w-full" styleClass="w-full" icon="pi pi-pen-to-square" severity="contrast" (click)="showEditDialog()" iconPos="right" /> -->
        <!-- <p-button (click)="showEditDialog()" label="Show" /> -->
        <!-- <p-dialog header="Edit Profile" [modal]="true" [(visible)]="visibleEditDialog" [style]="{ width: '25rem'; background: 'red'}">
            <span class="p-text-secondary block mb-8">Update your information.</span>
            <div class="flex items-center gap-4 mb-4">
                <label for="username" class="font-semibold w-24">Username</label>
                <input pInputText id="username" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex items-center gap-4 mb-8">
                <label for="email" class="font-semibold w-24">Email</label>
                <input pInputText id="email" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="visibleEditDialog = false" />
                <p-button label="Save" (click)="visibleEditDialog = false" />
            </div>
        </p-dialog> -->
      </div>
    </div>
  </div>
  <!-- <p-paginator [rows]="rows" [totalRecords]="subscriptions" [rowsPerPageOptions]="[10,15,20]" (onPageChange)="onPageChange($event)" class="mt-4"></p-paginator> -->
</section>